export interface IconInterface {
  size: {
    big: string
    medium: string
    small: string
    x: {
      big: string
      medium: string
      small: string
    }
    xx: {
      big: string
      medium: string
    }
  }
}

export const icon: IconInterface = {
  size: {
    big: '35px',
    medium: '20px',
    small: '15px',
    x: {
      big: '40px',
      medium: '25px',
      small: '10px'
    },
    xx: {
      big: '50px',
      medium: '30px'
    }
  }
}
